module.exports = __webpack_public_path__ + "static/media/1009191.fd2ea9dd.png";